import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import Customer from "../../models/Customer";
export var setCustomer = function setCustomer(state, payload) {
  state.customer = new Customer(payload);
};
export var setDefaultEmail = function setDefaultEmail(state, emailId) {
  state.customer.params.emails = state.customer.params.emails.map(function (email) {
    email.is_default = email.id === emailId;
    return email;
  });
};
export var setDefaultPhone = function setDefaultPhone(state, phoneId) {
  state.customer.params.phones = state.customer.params.phones.map(function (phone) {
    if (phoneId === phone.id) {
      phone.confirmed = true;
    }
    phone.is_primary_mobile = phoneId === phone.id;
    return phone;
  });
};
export var addEmail = function addEmail(state, email) {
  state.customer.params.emails.push(email);
};
export var deleteEmail = function deleteEmail(state, emailId) {
  state.customer.params.emails = state.customer.params.emails.filter(function (email) {
    return email.id !== emailId;
  });
};
export var deletePhone = function deletePhone(state, phoneId) {
  state.customer.params.phones = state.customer.params.phones.filter(function (phone) {
    return phone.id !== phoneId;
  });
};
export var addPhone = function addPhone(state, phone) {
  state.customer.params.phones.push(phone);
};
export var updateAddress = function updateAddress(state, address) {
  var addresses = state.customer.params.addresses;
  addresses.push(address);
  state.customer.params.addresses = addresses.map(function (a) {
    a.is_current = address.id === a.id;
    return a;
  });
};
export var reset = function reset(state) {
  state.customer = null;
};